import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  DIAM_API_PATH,
  DIAM_TEAM_ID,
  DiamRoleAccessRequestCreate,
  createMyRoleAccessRequest,
  diamQueryKeys,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useRequestRoleAccess() {
  const { getIdToken, apiUrl } = useApiEssentials(DIAM_API_PATH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: DiamRoleAccessRequestCreate) => {
      const idToken = await getIdToken();
      return createMyRoleAccessRequest(apiUrl, idToken, payload);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: diamQueryKeys.myTeamRoles(DIAM_TEAM_ID),
      });
    },
  });
}
